import { once } from 'ramda';
import { UserSyncArguments } from 'user-sync/index.types';
import { getUserSyncURL } from './utils';

const ID = '59';
const IABid = [58];

export const createPixel = (): HTMLImageElement => {
  const img = document.createElement('img');
  img.style.display = 'none';
  const redirect = getUserSyncURL(ID);
  img.src = `https://ssc-cms.33across.com/ps/?ri=0013300001kQj3GAAS&ru=${redirect}33XUSERID33X`;

  return img;
};

export default once(({ userSyncPixelsManager, fastdom, context }: UserSyncArguments): void =>
  userSyncPixelsManager.create(context.gdprConsent, ID, IABid, () => {
    const img = createPixel();
    fastdom.mutate(function userSync33acrossAddElement() {
      document.body.appendChild(img);
    });
  }),
);
